import { ENV } from '../config/ENV'
import axiosInterceptors from './axiosInterceptors'

export const TeamMemberService = {
  getEmployerTeamMembers,
  addEmployerTeamMember,
  updateEmployerTeamMember,
  inactivateEmployerTeamMember,
  activateEmployerTeamMember,
  deleteEmployerTeamMember,
  getUserMetaEnums,
}

function addEmployerTeamMember(createobj) {
  return axiosInterceptors
    .post(ENV.getEmployerTeamMembersUrl, createobj)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}

function getEmployerTeamMembers(
  search,
  status,
  role,
  itemsPerPage,
  currentPage,
  sortBy,
  sortOrder,
) {
  return axiosInterceptors
    .get(
      ENV.getEmployerTeamMembersUrl +
        '?search=' +
        search +
        '&status=' +
        status +
        '&role=' +
        role +
        '&ps=' +
        itemsPerPage +
        '&pn=' +
        currentPage +
        '&sortBy=' +
        sortBy +
        '&sortOrder=' +
        sortOrder,
    )
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}

function updateEmployerTeamMember(updateObj, teamMemberId) {
  let updateTeamMemberurl = ENV.getEmployerTeamMembersUrl + teamMemberId
  return axiosInterceptors
    .put(updateTeamMemberurl, updateObj)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}

function inactivateEmployerTeamMember(teamMemberId) {
  let inactivateTeamMemberUrl =
    ENV.getEmployerTeamMembersUrl + teamMemberId + '/inactivate'

  return axiosInterceptors
    .put(inactivateTeamMemberUrl)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}

function activateEmployerTeamMember(teamMemberId) {
  let activateTeamMemberUrl =
    ENV.getEmployerTeamMembersUrl + teamMemberId + '/activate'
  return axiosInterceptors
    .put(activateTeamMemberUrl)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}

function deleteEmployerTeamMember(teamMemberId) {
  let deleteTeamMemberUrl =
    ENV.getEmployerTeamMembersUrl + teamMemberId + '/terminate'
  return axiosInterceptors
    .put(deleteTeamMemberUrl)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}

function getUserMetaEnums() {
  return axiosInterceptors
    .get(ENV.getUserMetaDataEnumsUrl)
    .then((response) => {
      return response
    })
    .catch((error) => {
      return error
    })
}
